import { SET_ID } from "../../actions";
const initialState = {
  id:0,
};

const id = (state = initialState, action) => {
  switch (action.type) {
    case SET_ID:
      return {
        ...state,
        [action.inputType]: action.inputValue,
      };
    default:
      return state;
  }
};

export default id;
